import { render, staticRenderFns } from "./ProfileRunsDateFilter.vue?vue&type=template&id=28f12058&"
import script from "./ProfileRunsDateFilter.vue?vue&type=script&lang=ts&"
export * from "./ProfileRunsDateFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports